import { Component, OnInit } from '@angular/core';
import { filter, map, Observable } from 'rxjs';

import { AWSService } from '../services/aws.service';
import { Footer } from './interfaces/footer.interface';

@Component({
  selector: 'capq-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  prequalFooter$!: Observable<Footer>;
  currentYear: number | undefined;
  constructor(private readonly awsService: AWSService) {}
  ngOnInit(): void {
    this.setCurrentYear();

    this.prequalFooter$ = this.awsService.prequalifiedJSONData$.pipe(
      filter((data) => !!data),
      map((data) => data.prequalFooter)
    );
  }
  setCurrentYear(): void {
    const date = new Date();
    this.currentYear = date.getFullYear();
  }
}
